import { render, staticRenderFns } from "./cliente.vue?vue&type=template&id=84704d06&scoped=true&"
import script from "./cliente.vue?vue&type=script&lang=ts&"
export * from "./cliente.vue?vue&type=script&lang=ts&"
import style0 from "./cliente.vue?vue&type=style&index=0&id=84704d06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84704d06",
  null
  
)

export default component.exports